import { render, staticRenderFns } from "./whatsappDhAdminSettings.vue?vue&type=template&id=5c161bd0&scoped=true"
import script from "./whatsappDhAdminSettings.vue?vue&type=script&lang=ts"
export * from "./whatsappDhAdminSettings.vue?vue&type=script&lang=ts"
import style0 from "./whatsappDhAdminSettings.vue?vue&type=style&index=0&id=5c161bd0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c161bd0",
  null
  
)

export default component.exports